<template>
  <div class="footer-menu merge-menu">
    <ul>
      <li class="item home">
        <a :href="backIndex">
         <i></i>
         <p>返回首页</p>
       </a>
      </li>
      <!-- <li class="item explorer">
        <router-link :to="{ path: '/explorer' }">
         <i></i>
         <p>发现</p>
       </router-link>
      </li> -->
      <li class="item welfare">
        <router-link :to="{ path: '/my/welfare' }">
         <i></i>
         <p>福利</p>
       </router-link>
      </li> 
      <li class="item activity">
        <router-link :to="{ path: '/activity' }">
         <i></i>
         <p>活动</p>
       </router-link>
      </li> 

       <li class="item agh_tag">
       <span></span>
       <img src="../../assets/img/agh_nav_icon.png" alt="">
      </li>
    </ul>    
  </div>
</template>
<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import config from '../../../../config/config.js'
export default {
  data () {
    return {
     	  
    }
  },
  components:{

  },
  computed:{   	 	 
  	 ...mapGetters({
    }),
    backIndex(){
      return config.neigou_domin
    }
  },
  watch:{},
  created(){
      
  },
  methods:{
    
  },
  mounted(){

  }
}
</script>